export default __webpack_public_path__ + "static/media/assessment-level-2.2d804d0e.svg";